import { createApi } from "@reduxjs/toolkit/query/react";
import { transformRequest } from "../../../utils/API/requestMiddleware";
import { defaultBaseQuery } from "../../../utils/API/fetchBaseQuery";
import { transformErrorResponse, transformSuccessResponse } from "../../../utils/API/responseMiddleware";
import { encryptAES } from "../../../services/CryptoService";


const CommitteeWorkGroupApi = createApi({
    reducerPath: 'CommitteeWorkGroupApi',
    baseQuery: defaultBaseQuery,
    endpoints: (builder) => ({
        getWorkGroupMappingList: builder.mutation({
            query: (details) => ({
                url: `/CommitteeWorkGroup/GetAllCommitteeWorkGroupList`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        AddEditChapterDetails: builder.mutation({
            query: (details) => ({
                url: '/CommitteeWorkGroup/AddEditChapterDetails',
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),

        deleteWorkgroupMappingById: builder.mutation({
            query: (details) => ({
                url: `/CommitteeWorkGroup/DeleteCommitteeWorkgroupMapping`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        searchExcoMemberByEmail: builder.mutation({
            query: (details) => ({
                url: `/CommitteeWorkGroup/searchExcoMemberByEmail`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        getExcoMemberList: builder.mutation({
            query: (details) => ({
                url: `/CommitteeWorkGroup/GetExcoMemberList`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        AddEditExcoMembers: builder.mutation({
            query: (details) => ({
                url: `/CommitteeWorkGroup/AddEditExcoMembers`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        deleteEXCOMembers: builder.mutation({
            query: (details) => ({
                url: `/CommitteeWorkGroup/DeleteEXCOMembers`,
                method: 'POST',
                body: transformRequest(details),
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
        storeBase64Image: builder.mutation({
            query: (details) => ({
                url: '/Common/StoreBase64Image',
                method: 'POST',
                body: details,
            }),
            transformResponse: transformSuccessResponse,
            transformErrorResponse: transformErrorResponse,
        }),
    }),
})
export const {
    useGetWorkGroupMappingListMutation,
    useAddEditChapterDetailsMutation,
    useDeleteWorkgroupMappingByIdMutation,
    useSearchExcoMemberByEmailMutation,
    useGetExcoMemberListMutation,
    useAddEditExcoMembersMutation,
    useDeleteEXCOMembersMutation,
    useStoreBase64ImageMutation

} = CommitteeWorkGroupApi;

export default CommitteeWorkGroupApi;